import { combineReducers } from 'redux';
import steps from './bpm-steps.reducers';
const reducers = ()=>combineReducers({
        steps
    });
export default reducers;
